
    <!-- List quotation items -->
    <div *ngIf="items?.length" style="font-size: medium; font-weight: 500;" fxLayoutAlign="start center"></div>
    <mat-divider style="border: 1px solid lightgray;"></mat-divider>
    <div class="mx-4" fxLayout="column" fxLayoutAlign="start start">
            <div *ngFor="let data of items">
                <ng-container *ngIf="data?.product as product; else noLink">
                    <a [routerLink]="product?.type === 'quotation' 
                        ? ['/quotation', product?.quotationId]
                        : ((data?.sector?.seo?.slug) ? ['sector', data?.sector?.seo?.slug] : ['/']).concat([
                            (product?.layout || product?.type || 'product'),
                            (product?.seo?.slug || product?.slug || product?._id)
                          ])">
                        <div fxLayout="row" fxLayoutAlign="space-around center">
                            <span>{{ product?.name[this.translate.currentLang] }}</span>
                            <span class="mx-2" style="font-size: smaller;" *ngIf="data?.amount">X {{ data.amount | json }}</span>
                        </div>
                    </a>
                </ng-container>
                <ng-template #noLink>
                    <div fxLayout="row" fxLayoutAlign="space-around center">
                        <span *ngIf="data?.product?.name?.en">{{ data?.product?.name?.[this.translate.currentLang] || '-' }}</span>
                        <span class="mx-2" style="font-size: smaller;" *ngIf="data?.amount">X {{ data.amount | json }}</span>
                    </div>
                </ng-template>
                <mat-divider style="border: 1px solid lightgray;"></mat-divider>
            </div>
    </div>